import React from "react";

export function selectionCountLabel(count) {
  if (count === 0) return "Nenhuma sprint selecionada";
  return count === 1 ? "1 sprint selecionada" : `${count} sprints selecionadas`;
}

function SprintSelectionBar({ count }) {
  return (
    <div className={count > 0 ? "selectbar is-selected" : "selectbar"}>
      <span className="selection-count" aria-live="polite">
        {selectionCountLabel(count)}
      </span>
    </div>
  );
}

export default SprintSelectionBar;
